import { useEffect, useRef } from "react";

type Callback = (event: MouseEvent) => void;

function useOutsideClick(callback: Callback) {
  const ref = useRef<HTMLDivElement | null>(null);

  const handleClick = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      callback(event);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      handleClick(event);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

    // eslint-disable-next-line
  }, []);

  return ref;
}

export default useOutsideClick;
